export default "__VITE_ASSET__Bh22yTJX__"